import { Button, Form } from 'antd';

export const ResetButton = ({ onClick }: { onClick: () => void }) => (
  <Form.Item className="filter-control" style={{ margin: 0 }}>
    <Button onClick={onClick}>Reset</Button>
  </Form.Item>
);
